import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import DefaultModal from 'components/Utils/DefaultModal';
import { ReferralRequestDetails } from 'scenes/HomeStaff/ReferralsDirectory/ReferralRequest';

const CPPTimelineReferralRequest = (props) => {
  const [open, setOpen] = useState(false);

  const { request } = props;

  function onOpen() {
    setOpen(true);
  }

  const { send_to = {}, waiting_approval, instructions } = request;

  const description = send_to.name;
  const rootClassName = waiting_approval ? 'greyed-out' : '';

  return (
    <>
      <div className="item-wrapper clickable" onClick={onOpen}>
        <div className={rootClassName}>
          <div className="top-bar">
            <Icon src="user-doctor" />
            <span className="small-title">Referral Request</span>
          </div>
          <div className="item-content">
            <div className="inline-block">
              <span>{description}</span>
            </div>
            <span className="block">{instructions}</span>
          </div>
        </div>
      </div>
      {open && (
        <DefaultModal
          className="fit-modal"
          title="Referral Request"
          padding={false}
          wrap={true}
          content={
            <ReferralRequestDetails
              request={request}
              onDeleted={() => setOpen(false)}
              onClose={() => setOpen(false)}
            />
          }
          isOpen={open}
          onRequestClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

CPPTimelineReferralRequest.propTypes = {
  request: PropTypes.object.isRequired,
};

export default CPPTimelineReferralRequest;
